export type Priority = 'urgence' | 'action' | 'service' | 'activite' | 'statut' | 'suggestion'

export interface ForYouItem {
  id: string
  priority: Priority
  eyebrow: string
  title: string
  detail: string
  cta: string
  to: string
}

export interface EspaceService {
  id: string
  name: string
  context: string
  icon: 'card' | 'trash' | 'ball' | 'request' | 'booking' | 'invoice' | 'bell' | 'pet'
  to: string
}

export const citizenFirstName = 'Marianne'

export const forYouItems: ForYouItem[] = [
  {
    id: 'ebullition',
    priority: 'urgence',
    eyebrow: 'Avis d’ébullition',
    title: 'Votre adresse du 366, chemin Lakeshore est concernée.',
    detail: 'Secteur sud de l’autoroute 20 · en vigueur depuis aujourd’hui, 14 h 30.',
    cta: 'Voir les consignes',
    to: '/notifications',
  },
  {
    id: 'collecte',
    priority: 'service',
    eyebrow: 'Collectes',
    title: 'Collecte aujourd’hui',
    detail: 'Le camion est en route · matières organiques, secteur sud de l’autoroute 20',
    cta: 'Voir mes collectes',
    to: '/mes-collectes',
  },
  {
    // La carte citoyenne porte l'abonnement : Beaconsfield tourne sur SirsiDynix Horizon.
    id: 'bibliotheque',
    priority: 'action',
    eyebrow: 'Bibliothèque',
    title: '2 documents à rapporter',
    detail: 'Échéance le 10 octobre · renouvelable depuis votre carte',
    cta: 'Voir ma carte',
    to: '/ma-carte',
  },
  {
    id: 'natation',
    priority: 'activite',
    eyebrow: 'Loisirs',
    title: 'Natation d’Emma',
    detail: 'Samedi · 10 h · Centre récréatif de Beaconsfield',
    cta: 'Voir l’activité',
    to: '/mes-loisirs',
  },
  {
    id: 'demande',
    priority: 'statut',
    eyebrow: 'Demande #REQ-2790',
    title: 'Lampadaire défectueux — nouveau statut : En traitement',
    detail: '412, chemin Lakeshore · mis à jour le 25 septembre',
    cta: 'Suivre ma demande',
    to: '/mes-demandes/req-2790',
  },
  {
    id: 'inscription',
    priority: 'action',
    eyebrow: 'Inscription',
    title: 'La nouvelle plateforme d’inscription est en ligne',
    detail: 'Vos inscriptions aux activités se font maintenant ici, sans compte séparé.',
    cta: 'Voir la programmation',
    to: '/mes-loisirs',
  },
  {
    id: 'milo',
    priority: 'action',
    eyebrow: 'Mon animal',
    title: 'Rappel de vaccin pour Milo',
    detail: 'Prévu le 14 octobre · information partagée par Vet&Cie',
    cta: 'Voir Milo',
    to: '/mes-animaux/milo',
  },
]

export const espaceServices: EspaceService[] = [
  {
    id: 'carte',
    name: 'Carte numérique',
    context: 'Active · Centre récréatif, bibliothèque et loisirs',
    icon: 'card',
    to: '/ma-carte',
  },
  { id: 'collectes', name: 'Collectes', context: 'Collecte en cours aujourd’hui', icon: 'trash', to: '/mes-collectes' },
  { id: 'loisirs', name: 'Loisirs', context: '2 activités familiales cette semaine', icon: 'ball', to: '/mes-loisirs' },
  { id: 'demandes', name: 'Mes demandes', context: '1 demande en traitement', icon: 'request', to: '/mes-demandes' },
  { id: 'reservations', name: 'Réservations', context: 'Salles, chalets de parc et plateaux', icon: 'booking', to: '/mes-loisirs' },
  { id: 'factures', name: 'Factures', context: '1 facture à payer', icon: 'invoice', to: '/mon-profil' },
  { id: 'avis', name: 'Notifications', context: '3 avis non lus', icon: 'bell', to: '/notifications' },
  { id: 'animaux', name: 'Mes animaux', context: 'Milo · médaille active', icon: 'pet', to: '/mes-animaux' },
]

export const discoverItems = [
  {
    id: 'equipement',
    title: 'Découvrez la réservation de salles et de chalets de parc',
    detail: 'Chalets de Windermere, Shannon et Rockhill, réservés en ligne.',
    to: '/mes-loisirs',
  },
  {
    id: 'rappels',
    title: 'Recevez les rappels de collecte',
    detail: 'Un avis la veille, sur le canal de votre choix.',
    to: '/notifications/parametres',
  },
]

export interface EspaceNavItem {
  id: string
  label: string
  icon: 'home' | 'card' | 'profile' | 'bell' | 'trash' | 'request' | 'ball' | 'permit'
  to: string
}

export const espaceNav: EspaceNavItem[] = [
  { id: 'accueil', label: 'Accueil', icon: 'home', to: '/mon-espace' },
  { id: 'carte', label: 'Ma carte', icon: 'card', to: '/ma-carte' },
  { id: 'profil', label: 'Mon profil', icon: 'profile', to: '/mon-profil' },
  { id: 'avis', label: 'Notifications', icon: 'bell', to: '/notifications' },
  { id: 'collectes', label: 'Mes collectes', icon: 'trash', to: '/mes-collectes' },
  { id: 'loisirs', label: 'Loisirs', icon: 'ball', to: '/mes-loisirs' },
  { id: 'requete', label: 'Requête', icon: 'request', to: '/mes-demandes' },
  { id: 'permis', label: 'Permis', icon: 'permit', to: '/mes-permis' },
]

export interface LocalNewsItem {
  id: string
  date: string
  category: string
  title: string
  image: string
  to?: string
}

export const localNews: LocalNewsItem[] = [
  {
    id: 'depot-feuilles',
    date: '2 octobre 2026',
    category: 'Environnement',
    title: 'Ouverture du dépôt à feuilles, 300, chemin Beaurepaire',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5fd42455-d112-4234-8bf8-10181a8b6838.jpg',
    to: '/mes-collectes',
  },
  {
    id: 'sondage',
    date: '2 septembre 2026',
    category: 'Administration',
    title: 'Sondage sur les communications de la Ville',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5c1bb1a0-98ab-4fff-a0e3-94c11eaefb42.jpg',
  },
  {
    id: 'branches',
    date: '28 septembre 2026',
    category: 'Collecte',
    title: 'Dernière collecte de branches de l’automne à la fin octobre',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/66b2a568-92b6-454c-9209-0204adb6a2b4.jpg',
    to: '/mes-collectes/calendrier',
  },
]

export interface NearbyEvent {
  id: string
  date: string
  time?: string
  title: string
  image: string
}

export const nearbyEvents: NearbyEvent[] = [
  {
    id: 'trousse',
    date: 'Mar. 6 oct.',
    time: 'Dès 10 h',
    title: 'Trousse à emporter : l’Action de grâce',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/66b2a568-92b6-454c-9209-0204adb6a2b4.jpg',
  },
  {
    id: 'conversation',
    date: 'Mar. 6 oct.',
    time: 'Bibliothèque',
    title: 'L’heure de conversation : français',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7c3efef4-2477-4098-a5eb-04cd1fab915d.jpg',
  },
  {
    id: 'halloween',
    date: 'Sam. 31 oct.',
    time: 'De 16 h à 19 h',
    title: 'Fête de l’Halloween au parc Centennial',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/7165678e-95f5-4d80-b767-d3de456828e6.jpg',
  },
]

export interface UsefulService {
  id: string
  name: string
  open: boolean
  hours: string
  image: string
}

export const usefulServices: UsefulService[] = [
  {
    id: 'ville',
    name: 'Hôtel de ville de Beaconsfield',
    open: false,
    hours: 'Ouvre lundi 8 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d961d921-fc64-4172-a775-2646a67bcd2f.jpg',
  },
  {
    id: 'biblio',
    name: 'Bibliothèque de Beaconsfield',
    open: true,
    hours: 'Ferme à 20 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/66b2a568-92b6-454c-9209-0204adb6a2b4.jpg',
  },
  {
    id: 'recreatif',
    name: 'Centre récréatif',
    open: true,
    hours: 'Ferme à 21 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/5c1bb1a0-98ab-4fff-a0e3-94c11eaefb42.jpg',
  },
  {
    id: 'depot',
    name: 'Site de dépôt — 300, Beaurepaire',
    open: true,
    hours: 'Ferme à 15 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c135d2b5-e60f-4b53-a073-49b4840fbe05.jpg',
  },
  {
    id: 'culturel',
    name: 'Centre culturel Beaconsfield',
    open: false,
    hours: 'Ouvre mercredi 10 h',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0bf26428-32e7-41de-8bd9-514123997710.jpg',
  },
]

export const appBenefits = [
  { id: 'carte', label: 'Votre carte toujours avec vous', icon: 'card' },
  { id: 'alertes', label: 'Recevez ce qui vous concerne', icon: 'bell' },
  { id: 'lieu', label: 'Des services adaptés à l’endroit où vous êtes', icon: 'pin' },
  { id: 'photo', label: 'Signalez un problème en quelques secondes', icon: 'camera' },
  { id: 'acces', label: 'Accédez à vos activités et installations', icon: 'key' },
] as const

export const mobileItems = [
  { id: 'collecte', eyebrow: 'Collecte aujourd’hui', detail: 'Camion en route' },
  { id: 'biblio', eyebrow: 'Bibliothèque', detail: '2 documents à rapporter' },
  { id: 'demande', eyebrow: 'Demande #2790', detail: 'En traitement' },
]
